/** Colores de acento por rol — única fuente de verdad para tarjetas y organigrama visual. */
export const ORGANIGRAMA_ROLE_COLORS = {
  irene: "#00c2a3",
  miguel: "#f9a825",
  borja: "#b71c1c",
  imma: "#00897b",
  businessDeveloper: "#7b1fa2",
  guillermo: "#0277bd",
  agustina: "#1565c0",
  chiara: "#c2185b",
  disenadoras: "#5c6bc0",
  alex: "#00838f",
  nina: "#8d6e63",
  lydia: "#c2185b",
  mikael: "#757575",
  gemma: "#c2185b",
  estimates: "#e65100",
  samples: "#2e7d32",
  orders: "#b71c1c",
};

export const roleAccent = (roleId) =>
  ORGANIGRAMA_ROLE_COLORS[roleId] || "#1976d2";
